import styled from 'styled-components';
import { colors } from '../../design-system/tokens/colors';

export const GamePageContainer = styled.div`
  min-height: 100vh;
  background: ${colors.neutral.background.base};
`;
